import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-register-plan-card',
  templateUrl: './register-plan-card.component.html',
  styleUrls: ['./register-plan-card.component.scss']
})
export class RegisterPlanCardComponent implements OnInit {

  constructor() { }

  @Input() planDuration: number = 1;
  @Input() planExpiryDate: string = "9/16/2022";
  @Input() planPrice: number = 360;
  @Input() availableDiscount?: number;

  ngOnInit(): void {
  }

}
